import React from "react";
import LegalLayout, { Section } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service">
      <Section title="1. Acceptance">
        <p>By creating an account or using Setubuild.OS (the “Service”) you agree to these Terms. If you do not agree, do not use the Service.</p>
      </Section>

      <Section title="2. The Service">
        <p>Setubuild.OS provides construction site management software including AI photo inspection, daily progress reports, voice-note transcription, safety incident logging, worker attendance, team & equipment management, and WhatsApp notifications.</p>
      </Section>

      <Section title="3. Your Account">
        <ul className="list-disc pl-6 space-y-1">
          <li>You are responsible for keeping your credentials safe.</li>
          <li>One account per legal entity unless you purchase enterprise seats.</li>
          <li>You must be 18+ and legally authorized to bind your organization.</li>
        </ul>
      </Section>

      <Section title="4. Acceptable Use">
        <ul className="list-disc pl-6 space-y-1">
          <li>Do not upload illegal content, personal data of third parties without their consent, or content violating intellectual property rights.</li>
          <li>Do not reverse-engineer, scrape, or resell the Service.</li>
          <li>Do not send WhatsApp messages to recipients who have not opted in.</li>
          <li>Do not misuse AI features (e.g., to generate misleading safety reports).</li>
        </ul>
      </Section>

      <Section title="5. AI Outputs — Important Disclaimer">
        <p>The Service uses third-party AI models. Outputs (photo analyses, DPRs, chat answers, cost estimates) are <strong>advisory only</strong> and may contain errors. Safety-critical decisions must always be validated by a licensed engineer. Setubuild.OS is <strong>not liable</strong> for decisions made based on AI outputs.</p>
      </Section>

      <Section title="6. Subscription & Payment">
        <ul className="list-disc pl-6 space-y-1">
          <li>Paid plans are billed via Razorpay in INR.</li>
          <li>Renewals are automatic unless cancelled 24 hours before renewal.</li>
          <li>Refunds follow our <a href="/refund" className="text-primary underline">Refund Policy</a>.</li>
          <li>Taxes (GST) are added at checkout as applicable.</li>
        </ul>
      </Section>

      <Section title="7. Fair Use & Rate Limits">
        <p>To prevent abuse: 5 registration attempts per minute per IP, 10 login attempts per minute, and reasonable AI-request quotas per subscription tier. Excessive automated calls may lead to throttling or suspension.</p>
      </Section>

      <Section title="8. Suspension & Termination">
        <p>We may suspend or terminate accounts that violate these Terms with reasonable notice unless immediate action is required to protect users, data, or the platform. You may terminate anytime from Settings.</p>
      </Section>

      <Section title="9. Data Ownership">
        <p>You retain all rights to your data. You grant us a limited licence to process it solely to provide the Service.</p>
      </Section>

      <Section title="10. Limitation of Liability">
        <p>To the fullest extent permitted by law, our aggregate liability in any 12-month period is limited to the fees you paid us in that period. We are not liable for indirect, consequential, or lost-profit damages.</p>
      </Section>

      <Section title="11. Governing Law">
        <p>These Terms are governed by the laws of India. Exclusive jurisdiction: courts of Mumbai, Maharashtra.</p>
      </Section>

      <Section title="12. Changes">
        <p>We may update these Terms; we will notify by email 14 days before material changes.</p>
      </Section>

      <Section title="13. Contact">
        <p>SetuBuild Technologies · Bharat</p>
        <p>Email: <span className="mono">setubuildtechnologies@gmail.com</span> · Phone: +91 97667 44746</p>
        <p>Full contact form & details: <a href="/contact" className="text-primary underline">Contact us</a></p>
      </Section>
    </LegalLayout>
  );
}
